import { type IconProps, Stroke } from "./base";

/** The things a posting and a resume are about. */

/** A browser extension, as the browsers draw one. */
export function PuzzleIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M4 7h5a2 2 0 1 1 3 0h5v5a2 2 0 1 1 0 3v5H4z" />
        </Stroke>
    );
}

/** A place: the pin beside a posting's location. */
export function PinIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M12 21s-6-5.2-6-10.5a6 6 0 0 1 12 0C18 15.8 12 21 12 21z" />
            <circle cx="12" cy="10.5" r="2" />
        </Stroke>
    );
}

/** A file, for a record entry that names one. */
export function FileIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M7 3h7l5 5v13H7zM14 3v5h5" />
        </Stroke>
    );
}

/** The globe on Sign up to continue: the design draws no brand marks. */
export function GlobeIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18M3 12h18" />
        </Stroke>
    );
}

/** The tailors: a clipboard with a list on it. */
export function ClipboardListIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M9 4H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />
            <path d="M9 3h6v3H9zM9 11h.01M12.5 11H16M9 15h.01M12.5 15H16" />
        </Stroke>
    );
}
